import PageHero from '../components/PageHero.jsx';
import SportCard from '../components/SportCard.jsx';
import UilTimeline from '../components/UilTimeline.jsx';
import InfoIcon from '../components/InfoIcon.jsx';
import sports from '../data/sports.js';
import './SportsAndPE.css';

export default function SportsAndPE() {
  const { sixthGrade, uilSports, performanceGroups, uilRequirements } = sports;

  return (
    <div className="sports-pe">
      <PageHero
        icon="/assets/eagle/page-icons/sports.png"
        title="Sports & PE"
      />
      <p className="sports-pe-subtitle">
        Your options now, and what unlocks in 7th grade.
      </p>

      {/* ── Section 1: 6th grade ── */}
      <section className="sports-pe-section" id="sixth-grade">
        <h2 className="sports-pe-section-heading">Right now (6th grade)</h2>
        <p className="sports-pe-section-sub">
          These are your options for satisfying the physical activity requirement this year.
        </p>
        <div className="sports-pe-grid">
          {sixthGrade.map(sport => (
            <SportCard key={sport.id} sport={sport} variant="6th" />
          ))}
        </div>
      </section>

      {/* ── Section 2: 7th grade UIL ── */}
      <section className="sports-pe-section" id="uil-sports">
        <h2 className="sports-pe-section-heading">What unlocks in 7th grade</h2>
        <p className="sports-pe-section-sub">
          UIL sports become available starting in 7th grade. These run on a calendar — only some happen in the fall.
        </p>

        <UilTimeline sports={uilSports} />

        <div className="sports-pe-grid sports-pe-grid--uil">
          {uilSports.map(sport => (
            <SportCard key={sport.id} sport={sport} variant="uil" />
          ))}
        </div>
      </section>

      {/* ── Section 3: Performance groups ── */}
      <section className="sports-pe-section" id="performance-groups">
        <h2 className="sports-pe-section-heading">Performance groups</h2>
        <p className="sports-pe-section-sub">
          Cheer, Color Guard, and Dance Team. Year-long commitments — most require spring tryouts of 6th grade for the 7th-grade season.
        </p>
        <div className="sports-pe-grid">
          {performanceGroups.map(sport => (
            <SportCard key={sport.id} sport={sport} variant="performance" />
          ))}
        </div>
      </section>

      {/* ── Section 4: Universal requirements ── */}
      <section className="sports-pe-section" id="uil-requirements">
        <div className="sports-pe-requirements-card">
          <h2 className="sports-pe-req-heading">
            Before tryouts or first practice, every UIL athlete needs:
          </h2>
          <ul className="sports-pe-req-list">
            <li className="sports-pe-req-item">
              <strong>{uilRequirements.physical.label}</strong>
              {' '}— {uilRequirements.physical.description}
              <InfoIcon source={uilRequirements.physical.source} />
            </li>
            <li className="sports-pe-req-item">
              <strong>{uilRequirements.athleticPacket.label}</strong>
              {' '}— {uilRequirements.athleticPacket.description}
              <InfoIcon source={uilRequirements.athleticPacket.source} />
            </li>
            <li className="sports-pe-req-item">
              <strong>{uilRequirements.noPassNoPlay.label}</strong>
              {' '}— {uilRequirements.noPassNoPlay.description}
              <InfoIcon source={uilRequirements.noPassNoPlay.source} />
            </li>
          </ul>
          <p className="sports-pe-req-note">
            Mid-season transfers from outside the district require coach approval to join.
            <InfoIcon source={uilRequirements.midSeasonTransfers.source} />
          </p>
        </div>
      </section>
    </div>
  );
}
